(() => {
  'use strict';

  const tagName = 'video-hero';

  class VideoHero extends HTMLElement {
    constructor() {
      super();
      this.video = null;
      this.toggle = null;
      this.handleToggle = this.handleToggle.bind(this);
      this.handlePlay = this.handlePlay.bind(this);
      this.handlePause = this.handlePause.bind(this);
    }

    connectedCallback() {
      if (this.dataset.videoHeroReady === 'true') return;

      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-video-toggle]');
      this.dataset.videoHeroReady = 'true';

      if (!this.video || !this.toggle) return;

      this.toggle.addEventListener('click', this.handleToggle);
      this.video.addEventListener('play', this.handlePlay);
      this.video.addEventListener('pause', this.handlePause);

      if (this.prefersReducedMotion()) {
        this.video.pause();
        this.syncState(false);
        return;
      }

      this.play();
    }

    disconnectedCallback() {
      if (this.toggle) this.toggle.removeEventListener('click', this.handleToggle);
      if (this.video) {
        this.video.removeEventListener('play', this.handlePlay);
        this.video.removeEventListener('pause', this.handlePause);
        this.video.pause();
      }

      delete this.dataset.videoHeroReady;
      this.video = null;
      this.toggle = null;
    }

    prefersReducedMotion() {
      return document.body.classList.contains('motion-disabled') || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    async play() {
      if (!this.video) return;

      try {
        await this.video.play();
      } catch (error) {
        // Browsers can reject autoplay even when the video is muted. Keep the fallback usable.
        this.syncState(false);
      }
    }

    pause() {
      if (this.video) this.video.pause();
    }

    handleToggle() {
      if (!this.video) return;

      if (this.video.paused) {
        this.play();
      } else {
        this.pause();
      }
    }

    handlePlay() {
      this.syncState(true);
    }

    handlePause() {
      this.syncState(false);
    }

    syncState(isPlaying) {
      if (!this.toggle) return;

      const label = isPlaying ? this.toggle.dataset.labelPause : this.toggle.dataset.labelPlay;
      const icon = isPlaying ? '||' : '>';
      const labelNode = this.toggle.querySelector('.home-video-hero__toggle-label');
      const iconNode = this.toggle.querySelector('.home-video-hero__toggle-icon');

      this.toggle.setAttribute('aria-pressed', String(isPlaying));
      this.toggle.dataset.state = isPlaying ? 'playing' : 'paused';
      this.toggle.setAttribute('aria-label', label || '');
      if (labelNode && label) labelNode.textContent = label;
      if (iconNode) iconNode.textContent = icon;
    }
  }

  if (!customElements.get(tagName)) customElements.define(tagName, VideoHero);

  // Shopify's theme editor replaces section markup in place. Custom element
  // lifecycle hooks handle listeners, while this makes reload behavior explicit
  // for editors that retain a detached section for a short time.
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.(tagName).forEach((hero) => hero.connectedCallback());
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll?.(tagName).forEach((hero) => hero.disconnectedCallback());
  });
})();
